import { View } from 'react-native'
import { styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      zIndex: theme.zindexOverlay + 1,
      position: 'relative',
    },
  }
})
